import { useQuery } from "react-query";
import { getAllCarriers } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetAllCarriers = () => {
  return useQuery("GetAllCarriers", getAllCarriers, {
    refetchOnWindowFocus: false,
  });
};
